import uniqueEffectDefinitions from "./uniqueEffects.json";

function formatParameter(value, modifier) {
  if (modifier === "percent") {
    return String(Math.round(Number(value) * 100000) / 1000);
  }
  return String(value);
}

export function renderUniqueEffectDescription(effect) {
  if (!effect) return "";
  return String(effect.descriptionTemplate || "").replace(
    /\{([^}|]+)(?:\|([^}]+))?\}/g,
    (placeholder, key, modifier) => (
      Object.prototype.hasOwnProperty.call(effect.parameters || {}, key)
        ? formatParameter(effect.parameters[key], modifier)
        : placeholder
    ),
  );
}

export function getUniqueEffect(id) {
  const definition = uniqueEffectDefinitions[id];
  if (!definition) return null;
  return {
    ...definition,
    description: renderUniqueEffectDescription(definition),
  };
}

export function getUniqueEffects(ids) {
  return (Array.isArray(ids) ? ids : []).map(getUniqueEffect).filter(Boolean);
}

export { uniqueEffectDefinitions };
